// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'unwrap';

export const Component = () => (
  <path d='m21.436 12.975.052.057a.75.75 0 0 1-.052 1.003l-2.474 2.476-1.06-1.06 1.194-1.196h-5.19v-.005h-.156a.75.75 0 0 1 0-1.5h.5c.028 0 .056.002.083.005h4.762l-1.194-1.194 1.06-1.061zM4.7 17H3l3.272-9h1.952l3.276 9H9.8L7.282 9.79h-.068zm.243-3.695h4.602v1.27H4.943z' />
);

export const viewBox = '0 0 25 25';
